/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { ICarbonData } from '../../../../DashboardKPIWidgets/IEnergyManagementProps';
import { EnergyUsageField } from '../../../../shared/Enums';
import ProgressBarWidget from '../../../../shared/ProgressBar/ProgressBarWidget';
import { KPI_PERCENTAGE_DECIMAL_PRECISION } from '../../../../shared/Utils/Constants';
import { getProgressBarUnitScaledData } from '../../../../shared/Utils/portfolioDataFormatter';
import { ConversionType } from '../../../../shared/Utils/unitHandling/UnitModel';
import { ApiContext } from '../../../../../context/ApiContext';

interface ICarbonTabProps {
  data: ICarbonData;
  displayBaseline?: boolean;
}

export const SiteCarbonComponent = (props: ICarbonTabProps) => {
  const { data, displayBaseline } = props;

  const apiContext = useContext(ApiContext);

  const {
    emissionMeasurementUnit,
    totalAggregations: {
      totalActualEmission,
      totalPreviousPeriodEmission,
      totalDeviation,
      totalDeviationPercentage
    }
  } = data;

  const progressBarUnitScaledData = getProgressBarUnitScaledData(
    ConversionType.CARBON,
    {
      previousPeriod: totalPreviousPeriodEmission,
      actual: totalActualEmission
    },
    totalDeviation,
    emissionMeasurementUnit,
    undefined,
    null,
    null,
    emissionMeasurementUnit,
    apiContext.showChangeWhenData,
    true
  );

  const aggregationCarbonTabSite = {
    actual: progressBarUnitScaledData.actual,
    previousPeriod: progressBarUnitScaledData.previousPeriod,
    savings: progressBarUnitScaledData.deviation,
    actualUnit: progressBarUnitScaledData.actualUnit,
    baselineUnit: progressBarUnitScaledData.baselineUnit,
    changeUnit: progressBarUnitScaledData.changeUnit,
    savingsPercentage: parseFloat(
      totalDeviationPercentage.toFixed(KPI_PERCENTAGE_DECIMAL_PRECISION)
    )
  };

  return (
    <ProgressBarWidget
      unit={progressBarUnitScaledData.ConvertedUnit}
      category={EnergyUsageField.CARBONTABSITE}
      aggregationData={aggregationCarbonTabSite}
      displayBaseline={displayBaseline}
      renderedFromCarbon={true}
      fromCarbonKPI={true}
      originalUnit={emissionMeasurementUnit}
      conversionType={ConversionType.CARBON}
    />
  );
};
export default SiteCarbonComponent;
